import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from "./router";
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import './app.scss'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.config.productionTip = false

// Register service worker voor PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker geregistreerd:', registration);

        // Check voor updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // Nieuwe versie beschikbaar
              console.log('Nieuwe versie van de app beschikbaar!');

              // Je kunt hier een notificatie tonen aan de gebruiker
              if (confirm('Nieuwe versie beschikbaar! Wil je de pagina vernieuwen?')) {
                newWorker.postMessage({ type: 'SKIP_WAITING' });
                window.location.reload();
              }
            }
          });
        });
      })
      .catch(error => {
        console.error('Service Worker registratie mislukt:', error);
      });
  });
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
